fragment NextStepsFragment on FormNextSteps {
    slackMessage {
        id
        position
        slackChannel {
            name
            display
            externalId
        }
        channelId
        form {
            id
        }
    }
    nutshellNotification {
        id
        position
        notifiables {
            ... on User {
                id
                name
            }
        }
        form {
            id
        }
    }
}
